module.exports = __webpack_public_path__ + "static/img/bg-es.e7350121.png";